import GuidanceBodyStatement from "./GuidanceBodyStatement";
export default GuidanceBodyStatement;
